import { render, staticRenderFns } from "./AccountCompany.vue?vue&type=template&id=68271eea&scoped=true"
import script from "./AccountCompany.vue?vue&type=script&lang=js"
export * from "./AccountCompany.vue?vue&type=script&lang=js"
import style0 from "./AccountCompany.vue?vue&type=style&index=0&id=68271eea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68271eea",
  null
  
)

export default component.exports